import React, { useEffect } from 'react';
import { Modal, Form, Input, Col, Card, Row } from 'antd';
import ValidatorHelper from '../helpers/ValidatorHelper';
import StringHelper from '../helpers/StringHelper';
import UserServices from '../../services/UserServices';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function EditUserAgentWage({ userAgentWage }) {
    const { business, GET_USER_AGENT_WAGE } = usePersistedStore();
    const general = useGeneralStore();

    const visible = general.view.userEditAgentWageModal;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
    const [form] = Form.useForm();

    useEffect(() => {
        if (userAgentWage)
            form.setFieldsValue(userAgentWage);
        else
            form.resetFields();
    }, [form, userAgentWage]);

    function onEditUserAgentWageFinish(values) {

        UserServices.putUserAgentWage({
            UserId: values.UserId,
            BranchId: values.BranchId,
            WagePercent: parseFloat(StringHelper.getEnglishNum(values.WagePercent)),
            WagePrice: parseInt(values.WagePrice)
        }, token).then((res) => {
            general.ToggleUserEditAgentWage()
            form.resetFields()
            general.NotifSuccess('بروزرسانی با موفقیت انجام شد.');
            getUserAgentWage(values.UserId)

        }).catch((error) => {

        })

        function getUserAgentWage(recordId) {
            UserServices.getUserAgentWage(recordId, token).then((res) => {
                GET_USER_AGENT_WAGE(res.data)
            }).catch((error) => {

            })
        }

        // dispatch(putUserAgentWage({
        //     UserId: values.UserId,
        //     BranchId: values.BranchId,
        //     WagePercent: parseFloat(StringHelper.getEnglishNum(values.WagePercent)),
        //     WagePrice: parseInt(values.WagePrice)
        // }, () => { dispatch(ToggleUserEditAgentWage()) }, () => form.resetFields()));
    }

    return (
        <Modal
            width='60%'
            title="بروزرسانی کارمزد کاربر"
            visible={visible}
            footer={false}
            className="custom-table"
            onCancel={() => general.ToggleUserEditAgentWage()}>
            <Row gutter={24} justify="space-around" style={{ paddingTop: 20 }}>
                <Col span={24}>
                    <Card size="small" >
                        <Form form={form} onFinish={onEditUserAgentWageFinish}>
                            <Row gutter={24}>
                                <Col>
                                    <Form.Item name='UserId' value={userAgentWage.UserId}
                                    >
                                    </Form.Item>
                                </Col>
                                <Col span={5}>
                                    <Form.Item name='BranchId' label={`بیمه ${userAgentWage.BranchName}`}>
                                    </Form.Item>
                                </Col>
                                <Col span={7}>
                                    <Form.Item
                                        name='WagePercent'
                                        label='درصد کارمزد'
                                        rules={[
                                            ...ValidatorHelper.decimalNumber('درصد کارمزد')
                                        ]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={7}>
                                    <Form.Item name='WagePrice' label='مبلغ کارمزد'
                                        rules={[
                                            ...ValidatorHelper.number('مبلغ کارمزد')
                                        ]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item>
                                        <button type="primary" htmlType="submit" className="btn btn-primary btn-sm waves-effect waves-light"
                                            style={{ width: "100%" }}>
                                            <i className="fas fa-sync-alt font-size-16 align-middle mr-2"></i>بروزرسانی
                                        </button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Modal >
    )
}

